module.exports = __webpack_public_path__ + "static/media/0.b429c9a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shoes/0.png
// module id = 1048
// module chunks = 0